import * as React from "react";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";

export const getFormFieldTitle = (typeCol: ITaskTypeCol, showFieldName: boolean) => {
    if (!showFieldName) {
        return typeCol.title !== "&nbsp;" ? typeCol.title : <>&nbsp;</>;
    }
    return `${typeCol.title} (${typeCol.field})`;
};

export const getFormFieldTitleStr = (typeCol: ITaskTypeCol, showFieldName: boolean) => {
    return typeCol.title + (showFieldName ? ` (${typeCol.field})` : "");
};

export const getFormFieldTitleColor = (showFieldName: boolean, showFieldNameColor: string) => {
    return showFieldName ? showFieldNameColor : null;
};